import { useIntl } from "react-intl";

import TryIntent from "@/components/try-intent/src";
import { Link } from "@/libraries/design/components";
import { useLoggedInUser } from "@/utils/logged-in-user-provider";

import { CloudProductKey } from "../../constants";

import { useBacDeepUrl } from "./use-bac-deep-url";

type BuyNowButtonExperimentProps = {
    defaultUnitCount: number;
    unitCount: number;
    pricingPlanId: string;
    edition: string | undefined;
    dataProductKey: CloudProductKey;
    planName: string;
};

export const BuyNowButtonExperiment = (props: BuyNowButtonExperimentProps) => {
    const intl = useIntl();
    const userInfo = useLoggedInUser();
    const {
        defaultUnitCount,
        unitCount,
        pricingPlanId,
        dataProductKey,
        planName,
        edition
    } = props;

    const bacDeepUrl = useBacDeepUrl(
        userInfo.isUserLoggedIn,
        defaultUnitCount,
        unitCount,
        pricingPlanId
    );

    const buyButtonText = intl.formatMessage({
        id: "Pricing.PriceCard.BuyNow",
        defaultMessage: "Buy now"
    });

    return (
        <div>
            <TryIntent
                intentType="buy"
                containerId="priceBlockBuyNow"
                productKey={dataProductKey}
                edition={edition}
            >
                <Link
                    text={buyButtonText}
                    className="link-class"
                    type="anchor"
                    anchorProps={{ target: "_self" }}
                    dataEventProps={{
                        "data-product-key": dataProductKey,
                        "data-event-component": "linkButton",
                        "data-event-container": "priceBlockBuyNow",
                        "data-event": "clicked",
                        "data-label": `${planName}-buy-now`,
                        "data-label-english": `${planName}-buy-now`
                    }}
                    href={bacDeepUrl}
                />
            </TryIntent>
        </div>
    );
};
